import { configureStore } from '@reduxjs/toolkit'
import wallet from './slices/wallet';

export default configureStore({
  reducer: {
    wallet: wallet.reducer,
  },
})